/* eslint-disable react/no-array-index-key */
import React from 'react'
import { isEmpty } from 'lodash'
import ContentLoader from 'react-content-loader'
import { connect } from 'react-redux'
import { makeFichaAvisoURL } from '@navent-jobs/interlinking'

// ui-kit
import { useWindowSize } from '@navent-jobs/ui-kit/hooks/window-size'

// mixins
import { CardContainer, Container, Divider, Title } from './mixins'

// components
import Card from '../../../../components/card'
import ListadoAvisosPlaceholder from '../card/ListadoAvisosPlaceholder'
import { iaOrigenRecomendados } from '../../../../constants/origen-avisos-recomendados'

const CONFIDENCIAL = 'Confidencial'
const TOTAL_CARDS_PLACEHOLDER = 5
const IA_ORIGEN = iaOrigenRecomendados.listados

const ListadoAvisosRecomendados = ({ showRecommended, avisos, loading, labsParams }) => {
  const { isMobile } = useWindowSize()
  const iaOrigen = `ia_origen=${IA_ORIGEN}`
  const labsParamsStr = !isEmpty(labsParams)
    ? `?${new URLSearchParams(labsParams).toString()}&${iaOrigen}`
    : `?${iaOrigen}`

  const clickAvisoHandler = (event, url) => {
    if (!(event.ctrlKey || event.metaKey)) {
      event.preventDefault()
      window.open(url, isMobile ? '_self' : '_blank')
    }
  }

  if (loading)
    return (
      <Container>
        <Divider />
        <ContentLoader speed={2} width="170" height="40" viewBox="0 0 170 40">
          <rect x="0" y="4" rx="2" ry="2" width="170" height="14" />
        </ContentLoader>
        <ListadoAvisosPlaceholder total={TOTAL_CARDS_PLACEHOLDER} />
      </Container>
    )

  if (!showRecommended || !avisos || avisos.length < 1) return null

  return (
    <Container>
      <Divider />
      <Title>Empleos sugeridos según tus búsquedas</Title>
      {avisos.map((aviso, index) => {
        const url = `${makeFichaAvisoURL({
          ...aviso,
          empresa: {
            denominacion: aviso.empresa,
            confidencial: aviso.empresa === CONFIDENCIAL,
          },
        })}${labsParamsStr}`
        return (
          <CardContainer key={aviso}>
            <Card
              disableLink={false}
              aviso={aviso}
              index={index}
              onClick={({ event }) => clickAvisoHandler(event, url)}
              ubicacion="Listado Avisos Recomendados"
              link={url}
            />
          </CardContainer>
        )
      })}
    </Container>
  )
}

const states = ({ recomendadosStore }) => ({
  loading: recomendadosStore.status.loading,
  avisos: recomendadosStore.avisos,
  labsParams: recomendadosStore.labsParams,
})

export default connect(states)(ListadoAvisosRecomendados)
